import { useTranslation } from 'react-i18next';

import { INCIDENT_OPERATION_TEXT, type IncidentOperation } from '@ngsos/portal-core/commands';
import { INCIDENT_OPERATION_ICONS, OperationProgress } from '@ngsos/portal-ui';

export type IncidentOperationProgressProps = {
  operation: IncidentOperation;
  compact?: boolean;
  inverse?: boolean;
  testID?: string;
};

export function IncidentOperationProgress({ operation, compact, inverse, testID }: IncidentOperationProgressProps) {
  const { t } = useTranslation();
  const labels = INCIDENT_OPERATION_TEXT[operation];

  return (
    <OperationProgress
      icon={INCIDENT_OPERATION_ICONS[operation]}
      title={t(labels.title)}
      description={t(labels.description)}
      compact={compact}
      inverse={inverse}
      testID={testID}
    />
  );
}
